export class ResultStatusDto {
  isSuccess: boolean;
  message: string;
}
